import { Component } from '@angular/core';

@Component({
  selector: 'app-categories-header-admin',
  templateUrl: './categories-header-admin.component.html',
  styleUrl: './categories-header-admin.component.scss'
})
export class CategoriesHeaderAdminComponent {

}
